import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import findResult, { countSelected, findSelected } from '@/utils/resultsHelper';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import { columnDescription, columnName, columnSelect } from '@/constants/fields';
import { fitToPage, goToCodePage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import DictionariesTableHeader from '@/datasets/dictionaries/components/DictionariesTableHeader';
import DictionariesTableRows from '@/datasets/dictionaries/components/DictionariesTableRows';
import Filter from '@/components/Filter';
import SaveButton from '@/components/buttons/SaveButton';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import {
  fetchCohortDictionaries,
  newCohortFromDataset,
  toggleCohortDictionarySelected,
  updateCohortDictionariesFilter,
} from '../actions';

const columns = [
  columnSelect,
  columnName,
  columnDescription,
];

const SelectCohortDictionaries = ({
  category,
  code,
  fetchData,
  dictionaries,
  readErrors,
  readStatus,
  total,
  pageCount,
  currentPage,
  pageSize,
  onCheckBoxClick,
  filterTerm,
  updateFilterTerm,
  newCohort,
  datasetCode,
}) => {
  const { items, pageNumber } = fitToPage(dictionaries, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable aridhia-select-cohort-dictionaries" ref={ref}>
      <TableWrapper sticky celled className="aridhia-dictionaries-table" columns={columns} selectable>
        <DictionariesTableHeader
          dictionaries={items}
          readStatus={readStatus}
          readErrors={readErrors}
          currentPage={currentPage}
          columns={columns}
          hideColumns
        >
          <Filter
            className="aridhia-dictionaries-filter aridhia-table-filter"
            disabled={!datasetCode}
            filterTerm={filterTerm}
            updateFilter={({ value }) => updateFilterTerm(category, code, value)}
            error={firstErrorMessage(readErrors)}
            onFilter={() => fetchData(category, code, 1, null, false)}
          />
        </DictionariesTableHeader>
        <Table.Body>
          <DictionariesTableRows
            items={items}
            columns={columns}
            onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
            selectable
          />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="dictionary"
        goToPage={({ page }) => goToCodePage(fetchData, category, code, page, ref)}
        icon="th"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
      <SaveButton
        messageId="actions.start"
        minimumDataEntryMet={countSelected(dictionaries) > 0}
        onClick={() => newCohort(code, category, datasetCode, findSelected(dictionaries).map((d) => d.code))}
      />
    </div>
  );
};

const withoutItem = () => (
  {
    exists: false,
    readStatus: states.PENDING,
    dictionaries: [],
  }
);

const withItem = ({ datasets, dictionaries }) => {
  const selectedDatasets = findSelected(datasets.results);

  return ({
    exists: true,
    readStatus: dictionaries.readStatus,
    readErrors: dictionaries.readErrors,
    total: dictionaries.count,
    pageCount: dictionaries.totalPages,
    currentPage: dictionaries.currentPage,
    pageSize: dictionaries.pageSize,
    filterTerm: dictionaries.filter,
    dictionaries: dictionaries.results,
    datasetCode: selectedDatasets.length > 0 ? selectedDatasets[0].code : null,
  });
};

const mapStateToProps = ({
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code);
  return item ? withItem(item) : withoutItem();
};

const mapDispatchToProps = {
  fetchData: fetchCohortDictionaries,
  onCheckBoxClick: toggleCohortDictionarySelected,
  updateFilterTerm: updateCohortDictionariesFilter,
  newCohort: newCohortFromDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCohortDictionaries);
